var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgClock = function SvgClock(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2425_3883",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2425_3883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.16033 11.3632L11.4034 7.12014L10.548 6.26478L7.16033 9.65246L5.45263 7.94478L4.59727 8.80014L7.16033 11.3632ZM8.00033 15.6001C7.05675 15.6001 6.17265 15.4217 5.34803 15.0647C4.52342 14.7078 3.80445 14.2227 3.19111 13.6094C2.57779 12.996 2.09267 12.2771 1.73575 11.4524C1.37882 10.6278 1.20035 9.74372 1.20035 8.80014C1.20035 7.85655 1.37882 6.97245 1.73575 6.14784C2.09267 5.32322 2.57779 4.60425 3.19111 3.99092C3.80445 3.3776 4.52342 2.89248 5.34803 2.53556C6.17265 2.17862 7.05675 2.00016 8.00033 2.00016C8.94392 2.00016 9.82802 2.17862 10.6526 2.53556C11.4772 2.89248 12.1962 3.3776 12.8096 3.99092C13.4229 4.60425 13.908 5.32322 14.2649 6.14784C14.6218 6.97245 14.8003 7.85655 14.8003 8.80014C14.8003 9.74372 14.6218 10.6278 14.2649 11.4524C13.908 12.2771 13.4229 12.996 12.8096 13.6094C12.1962 14.2227 11.4772 14.7078 10.6526 15.0647C9.82802 15.4217 8.94392 15.6001 8.00033 15.6001ZM3.00341 0.710938L3.84647 1.554L0.754193 4.64628L-0.0888672 3.80322L3.00341 0.710938ZM12.9973 0.710938L16.0895 3.80322L15.2465 4.64628L12.1542 1.554L12.9973 0.710938ZM8.00033 14.4001C9.5552 14.4001 10.8773 13.8555 11.9665 12.7663C13.0557 11.6771 13.6003 10.355 13.6003 8.80014C13.6003 7.24527 13.0557 5.92322 11.9665 4.83398C10.8773 3.74475 9.5552 3.20014 8.00033 3.20014C6.44547 3.20014 5.12341 3.74475 4.03417 4.83398C2.94495 5.92322 2.40033 7.24527 2.40033 8.80014C2.40033 10.355 2.94495 11.6771 4.03417 12.7663C5.12341 13.8555 6.44547 14.4001 8.00033 14.4001Z",
    fill: "white"
  }))));
};
export default SvgClock;